import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        {/* <Header /> */}
        <CFView
          h="100vh"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
          justifyStart
          alignCenter
          textCenter
        >
          <CFImage
            mt="25px"
            w="90%"
            src={mobileHeroText}
            alt="Mr Chibap Korean Cuisine hero text"
            zIndex={98}
          />
          <CFView pulsate mt="25px">
            <OrderPickupButton />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <Header />
        <CFView
          h="92vh"
          maxHeight="690px"
          w="100%"
          image={`url(${hero}) bottom/ cover no-repeat`}
          zIndex={90}
          column
          justifyCenter
          alignStart
        >
          <CFView column justifyCenter alignStart ml="5vw">
            <CFImage
              w="48vw"
              maxWidth="550px"
              src={heroText}
              alt="Mr Chibap Korean Cuisine hero text"
              zIndex={98}
            />
            <CFView pulsate w="35vw" mt="30px" ml="15px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
